import { isFlyin } from '@/src/utils/generalUtils/isFlyin'

type WalletHrefOptions = {
    nonFlyinPath?: string
}

export const getWalletHref = (locale: string, options?: WalletHrefOptions): string => {
    const nonFlyinPath = options?.nonFlyinPath ?? '/wallet'
    return isFlyin() ? `/${locale}/wallet` : nonFlyinPath
}
